/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../../core/utils"
import { completeBlocClassName, incompleteBlockClassName } from "../constants/ClientPageConstants"
import React from "react"
import { Col, Row } from "react-bootstrap"

export default function Bloc(props) {
  const blocIsCompleted = props.completedFields === props.totalFieldsNumber

  return (
    !props.hide && (
      <Col lg={6}>
        <header className={blocIsCompleted ? completeBlocClassName : incompleteBlockClassName}>
          <Row className="justify-content-between">
            <Col className="align-self-center block-title-width">
              <h2>{loc(props.name, { data: props?.data })}</h2>
            </Col>
            <Col className="align-self-center">
              <p className="counter">
                {props.completedFields} / {props.totalFieldsNumber}
              </p>
            </Col>
          </Row>
        </header>
        {props.children}
      </Col>
    )
  )
}
